/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Store } from './Store';
// @ts-ignore
import {
// @ts-ignore
    StoreFromJSON,
// @ts-ignore
    StoreFromJSONTyped,
// @ts-ignore
    StoreToJSON,
} from './Store';

/**
 * 
 * @export
 * @interface StoreListResponse
 */
export interface StoreListResponse {
    /**
     * 
     * @type {number}
     * @memberof StoreListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Store>}
     * @memberof StoreListResponse
     */
    items: Array<Store>;
}

/**
 * Check if a given object implements the StoreListResponse interface.
 */
// @ts-ignore
export function instanceOfStoreListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function StoreListResponseFromJSON(json: any): StoreListResponse {
    return StoreListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(StoreFromJSON)),
    };
}

// @ts-ignore
export function StoreListResponseToJSON(value?: StoreListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(StoreToJSON)),
    };
}

